import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosTooltip } from './tooltip'
import { IcosSharedModule } from '../shared/module'

export function getWindow(): any { return window }

@NgModule({
  declarations: [IcosTooltip],
  exports: [IcosTooltip],
  imports: [CommonModule, IcosSharedModule],
  entryComponents: [IcosTooltip],
})
export class IcosTooltipModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosTooltipModule, providers: []}
  }
}
